import {
    ActionItem,
    ActionItemStyle,
    OpenDirection
} from '../../elements/components/action-item/entities/action-item.entity';
import { Observable } from 'rxjs';

export const EllipsisMultiActionItem = (
    actions: ActionItem[],
    disabled: boolean = false,
    style: ActionItemStyle = ActionItemStyle.Ghost,
    openDirection: OpenDirection = OpenDirection.LeftOverlap,
    disabledInfoMsg: string = ''
): ActionItem => ({
    label: '',
    icon: 'ellipsis-h',
    style,
    openDirection,
    actionItems: actions,
    disabled: actions.length === 0 || disabled,
    disabledInfoMsg
});

export const AsyncEllipsisMultiActionItem = (
    actions: Observable<ActionItem | null>[],
    disabled: boolean = false,
    style: ActionItemStyle = ActionItemStyle.Ghost,
    openDirection: OpenDirection = OpenDirection.LeftOverlap,
    disabledInfoMsg: string = ''
): ActionItem => ({
    label: '',
    icon: 'ellipsis-h',
    style,
    openDirection,
    asyncActionItems: actions,
    disabled: actions.length === 0 || disabled,
    disabledInfoMsg
});
